import * as React from "react";
import styled, { css } from "styled-components";
import { v4 as uuid } from "uuid";

import Grid from "src/library/components/Hedron";
import { Text } from "src/library/components/Text";
import { Tooltip } from "src/library/components/Tooltip";

interface ProductUnavailableTagProps {
  reason?: string;
}

export const ProductUnavailableTag: React.ReactFCWithChildren<ProductUnavailableTagProps> = ({ reason }) => {
  const tippyKey = `${uuid()}`;

  return (
    <ProductUnavailableTagWrapper
      className="product-unavailable"
      valign="center"
    >
      <div
        className="tag"
        data-tip
        data-for={tippyKey}
      >
        <Text
          color="primary"
          weight="bold"
        >
          Unavailable
        </Text>
      </div>

      <Tooltip
        id={tippyKey}
        type="dark"
        disable={!reason}
        getContent={() => {
          return (
            <Text color="white">
              {reason}
            </Text>
          );
        }}
      />
    </ProductUnavailableTagWrapper>
  );
};

const ProductUnavailableTagWrapper = styled(Grid.Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    margin-right: ${theme.spacing.margins.md};
		opacity: 1;

    .tag {
      margin-right: 3px;
      padding: ${theme.spacing.padding.xs} ${theme.spacing.padding.md};
      background: ${theme.colors.lightGrey};
      border-radius: ${theme.borderRadius};

			&:hover {
				cursor: help;
			}
    }
  `}
`;
